export const destructureData = (data) => {
  const pages = loadSurveyPages(data);
  return { questionnaire: data.questionnaire, pages };
};

export const loadSurveyPages = (data) => {
  if (data.pages) {
    return data.pages;
  } else {
    const generatedDimensionsArray = [...Array(data.questionnaire.length + 1).keys()].slice(1);
    // La finalidad de esta función es retornar un arreglo en formato [pagina 1: dimension 1, pagina 2: dimension 2, etc...]
    return generatedDimensionsArray.reduce(
      (array, index) => ({
        ...array,
        [index]: [index],
      }),
      {}
    );
  }
};
